import PublisherOverview from "@panel/publisher/overview";
import PublisherEarnings from "@panel/publisher/earnings";
import PublisherContracts from "@panel/publisher/contracts";
import PublisherKyc from "@panel/publisher/kyc";
import PublisherGuide from "@panel/publisher/guide";
import PublisherIndexRedirect from "@panel/publisher/index-redirect";

// Mirrors Nook Pay Hub's /publisher/* routes (src/routes/publisher.tsx), scoped to
// whichever publisher account is selected in the topbar switcher.
const PublisherRoutes = [
    {
        path   : "publisher",
        element: <PublisherIndexRedirect />,
        meta   : {
            resource: "publisher-overview",
            title   : "Publisher Overview",
            action  : "read"
        }
    },
    {
        path   : "publisher/:publisherId/overview",
        element: <PublisherOverview />,
        meta   : {
            resource: "publisher-overview",
            title   : "Publisher Overview",
            action  : "read"
        }
    },
    {
        path   : "publisher/:publisherId/earnings",
        element: <PublisherEarnings />,
        meta   : {
            resource: "publisher-earnings",
            title   : "Publisher Earnings",
            action  : "read"
        }
    },
    {
        path   : "publisher/:publisherId/contracts",
        element: <PublisherContracts />,
        meta   : {
            resource: "publisher-contracts",
            title   : "Publisher Contracts",
            action  : "read"
        }
    },
    {
        path   : "publisher/:publisherId/kyc",
        element: <PublisherKyc />,
        meta   : {
            resource: "publisher-kyc",
            title   : "Publisher KYC",
            action  : "read"
        }
    },
    {
        path   : "publisher/:publisherId/guide",
        element: <PublisherGuide />,
        meta   : {
            resource: "publisher-guide",
            title   : "Publisher User Guide",
            action  : "read"
        }
    }
];

export default PublisherRoutes;
